<div
  [class]="'main ' + theme"
  (click)="handleClick($event)"
  (mouseenter)="handleHover($event)"
  (mouseleave)="handleHover($event)"
  [title]="podtitle ?? ''"
>
  <div class="header">{{ headerlabel }}</div>

  <div [class]="contentClass" [style]="contenttextstyleoverride ?? ''">
    @if (
      enablespinner &&
      (contenttext === undefined || contenttext === null || contenttext === "")
    ) {
      <div class="spinner-container">
        <mat-spinner class="spinner" color="gray"></mat-spinner>
      </div>
    }
    @if (
      contenttext !== undefined && contenttext !== null && contenttext !== ""
    ) {
      @if (contenttext === "!") {
        <span class="content-error">{{ contenttext }}</span>
      } @else {
        <span
          [class]="active ? 'content-text active' : 'content-text inactive'"
          >{{ contenttext }}</span
        >
      }
    }

    @if (contentimagesrc !== undefined) {
      <img
        [src]="contentimagesrc"
        [style]="contentimagestyleoverride ?? ''"
        [class]="contentimageclass ?? ''"
        [alt]="contentimagealt ?? ''"
      />
    }

    @if (displayBottomArrows()) {
      <!-- @if (
            !active &&
            contenttext !== undefined &&
            contenttext !== null &&
            contenttext !== '!'
          ) { -->
      <mat-icon
        [class]="
          !active &&
          contenttext !== undefined &&
          contenttext !== null &&
          contenttext !== ''
            ? 'bottom-arrow'
            : 'bottom-arrow rotate'
        "
        >arrow_drop_down</mat-icon
      >
      <!-- } @else {
            <mat-icon class="bottom-arrow rotate">arrow_drop_down</mat-icon>
          } -->
    }

    <!-- Example data value display for debugging purposes -->
    @if (exampleDataValue() !== undefined) {
      <div class="data-display" (click)="clearExampleDataValue()">
        <pre>{{ exampleDataValue() }}</pre>
      </div>
    }
  </div>
</div>

<mat-icon class="bottom-arrow" style="display: none">arrow_drop_down</mat-icon>
